export default __webpack_public_path__ + "static/1.1_FR-98f59200479f1db17b19ad51b22bcbaf.png";